import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../App.routing'

const curation = 'federal-election-2022'

export const electionDayContent = [
    layout.nestedComposition({
        type: 'janus',
        props: {
            hasBackgroundFill: true,
            layoutRatio: '3:1',
            stretchColumns: false,
        },
        contentAreas: {
            left: [
                layout.component({
                    type: 'sierra',
                    props: {
                        verticalSpacing: 'gridGap',
                        fixedRatios: ['16:9'],
                        heroImageLayout:
                            ResponsivePictureLayout.ObjectFitContain,
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                            maxBreakpoint: 'md',
                        },
                        cardLayout: ['hero'],
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            offset: 0,
                            pageSize: 1,
                        },
                    },
                }),
            ],
            right: [
                layout.component({
                    type: 'lima',
                    props: {
                        fixedRatios: ['16:9'],
                        heroImageLayout:
                            ResponsivePictureLayout.ObjectFitContain,
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                            maxBreakpoint: 'md',
                        },
                        finalColumns: 1,
                        hasBorder: false,
                        cardLayout: [
                            {
                                type: 'november',
                                listLength: 4,
                                verticalSpacing: 'md',
                            },
                        ],
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            offset: 1,
                            pageSize: 4,
                        },
                    },
                }),
            ],
        },
    }),
    layout.component({
        type: 'federal-election-widget-collection',
        props: {
            layout: 'horizontal',
        },
    }),
]

export const preElectionDayContent = [
    layout.component({
        type: 'sierra',
        props: {
            verticalSpacing: 'gridGap',
            fixedRatios: ['16:9'],
            heroImageLayout: ResponsivePictureLayout.ObjectFitContain,
            cardOrientation: {
                type: 'Landscape-Portrait',
                maxBreakpoint: 'md',
            },
            cardLayout: ['hero', 'teaser-xsVisible-mdHidden-Image'],

            dataDefinitionArgs: {
                type: 'curation',
                name: curation,
                offset: 0,
                pageSize: 2,
            },
        },
    }),
    layout.nestedComposition({
        type: 'thor',
        props: {
            hasBackgroundFill: false,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: false,
            verticalSpacing: 'unset',
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'lima',
                    props: {
                        section: 'default',
                        hasBackground: false,
                        hasBorder: false,
                        cardLayout: [
                            [
                                {
                                    type: 'landscape-stacked',
                                    format: 'landscape-stacked-noteaser',
                                },
                                {
                                    type: 'landscape-stacked',
                                    format: 'landscape-stacked-noteaser',
                                },
                                {
                                    type: 'landscape-stacked',
                                    format: 'landscape-stacked-noteaser',
                                },
                            ],
                            ['noImage-noBackground', 'noImage-noBackground'],
                            ['noImage-noBackground', 'noImage-noBackground'],
                            ['teaserSmallTitle'],
                        ],
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                        },
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            offset: 2,
                            pageSize: 8,
                        },
                    },
                }),
            ],
        },
    }),
]

export const federalElectionSegment = () => {
    return layout.nestedComposition({
        type: 'thor',
        feature: 'federal-election-2022-federal-collection',
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: 'federal-election',
            verticalSpacing: 'unset',
        },
        contentAreas: {
            main: preElectionDayContent,
        },
    })
}
export const postFederalElectionSegment = (showWidgets: boolean) => {
    return layout.nestedComposition({
        type: 'thor',
        feature: 'federal-election-2022-election-day',
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: 'federal-election',
            verticalSpacing: 'unset',
            layout: 'horizontal',
        },
        contentAreas: {
            main: showWidgets ? electionDayContent : preElectionDayContent,
        },
    })
}
